
<div id="print-section" class="max-w-4xl mx-auto my-10  border-2 border-gray-400">
  <!-- Header -->
  <header class="bg-[#006269] text-white p-6">
    <div class="flex justify-between items-center">

      <!-- Left: Applicable From -->
      <div class="text-left">
        <!-- <p class="text-lg">Applicable From</p>
        <p class="text-lg">28th-July-2025</p> -->
        <p class="text-lg font-bold">{{ customerType }}</p>
      </div>

      <!-- Center: Logo + Brand -->
      <div class="flex flex-col items-center">
        <div class="flex items-center space-x-4">
          <!-- Circular Logo -->
          <span class="w-25 h-25 flex items-center justify-center overflow-hidden ">
            <img src="/assets/images/rate-list/rate-list2.png" alt="Logo" class="w-full h-full object-contain" />
          </span>

          <!-- Brand Logo (bigger than the text) -->
          <img src="/assets/images/rate-list/meena.png" alt="Meena Logo" class="h-20 md:h-28 object-contain" />
        </div>


        <!-- <p class="text-sm tracking-widest mt-1">S T E R L I N G  S I L V E R</p>
        <p class="text-xs italic">Wear Your Pride</p> -->
      </div>

      <!-- Right: Office Info -->
      <div class="text-right">
        <p class="text-lg">Office</p>
        <p>86838 36136</p>
        <p class="mt-2 text-lg">Parveen Soni</p>
        <p>7976063331</p>
        <p>7728034217</p>
      </div>

    </div>

    <h1 class="text-4xl text-center">Rate List</h1>
  </header>

  <main class="p-4">
    <!-- Loop categories -->
<div *ngFor="let category of categories">
  <div class="bg-[#00acb2] text-white text-center py-1 text-xl font-semibold mt-6">
    {{ categoryWiseItems[category][0].category?.name }}
  </div>

  <table class="w-full border-collapse border border-gray-400">
    <thead class="bg-gray-200">
      <tr>
        <th class="border p-2">Code</th>
        <th class="border p-2">Weight Range</th>
        <!-- <th class="border p-2">Customer Type</th> -->
        <th class="border p-2">Rate / Labour / Disscount</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of categoryWiseItems[category]" class="text-center">
        <td class="border p-2">{{ item.rlg_code || '-' }}</td>
        <td class="border p-2">{{ formatWeightRange(item) }}</td>
        <!-- <td class="border p-2">{{ item.rlg_customer_type || '-' }}</td> -->
        <td class="border p-2">
          <!-- By Gram -->
          <ng-container *ngIf="item.rlg_unit === 'By Gram'">
            Silver + {{ item.rlg_per_gm_labour }} /- Per Gram Labour
          </ng-container>

          <!-- By Silver Rate -->
          <ng-container *ngIf="item.rlg_unit === 'By Silver Rate'">
            {{ item.rlg_purity | number:'1.0-0' }} % Silver Value
          </ng-container>

        <!-- By Silver Rate -->
          <ng-container *ngIf="item.rlg_unit === 'By MRP'">
            {{ item.rlg_discount | number:'1.0-0' }} % Discount
          </ng-container>
        </td>
      </tr>
    </tbody>
  </table>

  <!-- ✅ Footer rule (Below on MRP) -->
  <div
    *ngIf="categoryFooter[category]"
    class="text-center bg-gray-50 border border-gray-400 p-3 font-semibold"
  >
    {{ categoryFooter[category].label }} → {{ categoryFooter[category].value }}
  </div>
</div>

  </main>


  <!-- Footer / Notes -->
  <footer class="bg-[#D9E2F3] p-4 text-[#0F2E56]">
    <h3 class="font-semibold text-lg mb-2">Note:</h3>
    <ul>
      <li class="flex items-start mb-1"><span class="mr-2">❖</span><span>All Products Come With Premium Brand
          Packaging.</span></li>
      <li class="flex items-start mb-1"><span class="mr-2">❖</span><span>A 5% Discount Will Be Applied If Packaging Is
          Not Required.</span></li>
      <li class="flex items-start mb-1"><span class="mr-2">❖</span><span>5% Discount Is Not Applicable On Thread Payal /
          Nazariya / Pearl Bracelet.</span></li>
      <li class="flex items-start mb-1"><span class="mr-2">❖</span><span>The Silver Rate Will Be Based On The Current
          Day's Silver Price.</span></li>
      <li class="flex items-start mb-1"><span class="mr-2">❖</span><span>Only Meena Silver Is Authorized To Change The
          Rates.</span></li>
      <li class="flex items-start mb-1"><span class="mr-2">❖</span><span>We Guarantee 100% Genuine And Authentic
          Products.</span></li>
      <li class="flex items-start mb-1"><span class="mr-2">❖</span><span>It Is Recommended To Keep The Silver Jewelry In
          The Company-Provided Packaging To Avoid Black Tarnish And Dullness.</span></li>
      <li class="flex items-start mb-1"><span class="mr-2">❖</span><span>3% GST Will Be Applicable.</span></li>
    </ul>
  </footer>
</div>
<div class="text-center no-print">
  <button
    (click)="printInvoice()"
    class="bg-[#006269] text-white px-4 py-2 rounded shadow hover:bg-[#004d52]">
    🖨️ Print
  </button>
</div>

